module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    style: (_vm.imgSize),
    attrs: {
      "src": _vm.logo
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b68de7c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Icon.vue
// module id = 795
// module chunks = 1